<template>
  <div>
    <Head>
      <Title>{{ $t('pages.results.meta.title', useTeamParams()) }}</Title>
      <Meta name="description" :content="$t('pages.results.meta.description', useTeamParams())" />
      <!-- <Link rel="canonical" :href="useAbsolutePath()" /> -->
    </Head>
    <div class="space-y-4">
      <TeamNavResults />
      <PartialsGames :games="games" />
      <TeamSeoText type="results" class="mt-8" />
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'team'
})

const route = useRoute()
const team = useTeamStore()

const side = computed(() => route.query?.side || undefined)

const { data } = await useFetch(`/api/v1/teams/${team.slug}/games`, { 
  key: `team-results-${team.slug}`,
  baseURL: useEnv('apiBase'),
  query: {
    untilDate: useDate().add(-1, 'day').format('YYYY-MM-DD'),
    side: computed(() => side.value),
  }
})

const games = computed(() => [...data.value?.games]?.reverse())
</script>